var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticStyle:{"pointer-events":"none"},attrs:{"transform":_vm.transform}},[_c('circle',{staticStyle:{"pointer-events":"none"},attrs:{"r":7,"fill":"red"}})])}
var staticRenderFns = []

export { render, staticRenderFns }